
import { Dispatch, SetStateAction } from 'react';

export interface Coordinates {
  lat: number;
  lng: number;
}

export type Permission = 'granted' | 'denied' | 'prompt';

export interface LocationState {
  coords: Coordinates | null;
  permission: Permission;
  isLoading: boolean;
  error: string | null;
  permissionTransitioning: boolean;
  lastUpdated: number | null;
  initialized: boolean; // Added to track initialization status
}

export interface PromptState {
  lastPromptTime: number | null;
  promptCount: number;
  interactionCount: number;
  cooldownEndTime: number | null;
  hasShownPrompt: boolean;
}

export interface LocationConfig {
  cooldownPeriod: number; // in hours
  minInteractionsBeforePrompt: number;
  maxPromptFrequency: number; // max times to show prompt
  updateInterval: number; // in milliseconds
  permissionCheckInterval: number; // in milliseconds
  staleTolerance: number; // in minutes
}

export const DEFAULT_CONFIG: LocationConfig = {
  cooldownPeriod: 24, // 24 hours cooldown after "Maybe Later"
  minInteractionsBeforePrompt: 2, // Show prompt after 2 meaningful interactions
  maxPromptFrequency: 3, // Show prompt max 3 times
  updateInterval: 5 * 60 * 1000, // update location every 5 minutes
  permissionCheckInterval: 60 * 1000, // check permission every minute
  staleTolerance: 30, // location is stale after 30 minutes
};

export const STORAGE_KEYS = {
  COORDS: 'lastKnownLocation',
  TIMESTAMP: 'locationTimestamp',
  PERMISSION: 'locationPermission',
  LAST_PROMPT: 'lastLocationPromptTime',
  PROMPT_COUNT: 'locationPromptCount',
  INTERACTIONS: 'userInteractionCount',
  COOLDOWN: 'locationCooldownEndTime',
  DO_NOT_SHOW_AGAIN: 'locationDoNotShowAgain',
};
